import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { ReferrersHttpClient } from './referrers.http-client';
import { ReferralsReferrerActions } from './referrers.store';

@Injectable({ providedIn: 'root' })
export class ReferralsReferrerEffects {
  public effects = createEffectFactory(ReferralsReferrerActions, this.actions$);

  public fetch$ = this.effects(ReferralsReferrerActions.fetchPaginatedCollection, ({ payload }) =>
    this.http.loadReferrers(payload.params).pipe(
      map(data => ({
        data,
      })),
    ),
  );

  public deleteAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReferralsReferrerActions.deleteMany),
      switchMap(({ payload }) =>
        this.http.deleteReferrers(payload.ids).pipe(
          switchMap(() => [ReferralsReferrerActions.deleteManySuccess({ payload })]),
          catchError((error: HttpErrorResponse) =>
            of(ReferralsReferrerActions.deleteManyFailed({ payload: { error, data: payload } })),
          ),
        ),
      ),
    ),
  );

  public invite$ = this.effects(ReferralsReferrerActions.inviteReferrer, ({ payload }) =>
    this.http.inviteReferrers(payload.emails, payload.message).pipe(
      switchMap(({ emailsSent }) => [
        ReferralsReferrerActions.inviteReferrerSuccess({
          payload: { emailsSent },
        }),
      ]),
      catchError(error =>
        of(
          ReferralsReferrerActions.inviteReferrerFailed({
            payload: { error },
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private http: ReferrersHttpClient,
  ) {}
}
